
  <mat-paginator [length]="totalItems"
                [pageSize]="itemsPerPage"
                [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true"
                (page)="tablePageChanged($event)">
  </mat-paginator>
